module.exports = __webpack_public_path__ + "static/media/popoverRescinded.64e13ef0.png";